export default function Alphabet() {
  return [];
}
